import { RecaptchaAction } from '@/constants/recaptcha-action';

export async function getToken(
    googleRecaptchaSiteKeyId: string,
    action: string = RecaptchaAction.CheckoutChargeToken
): Promise<any> {
    return await new Promise((resolve, reject) => {
        grecaptcha.enterprise.ready(() => {
            try {
                grecaptcha.enterprise
                    .execute(googleRecaptchaSiteKeyId, { action })
                    .then(async (token) => {
                        resolve({
                            success: true,
                            data: { token }
                        });
                    }, reject);
            } catch (error) {
                resolve({
                    success: false,
                    data: {
                        message: error
                    }
                });
            }
        });
    });
}
